module.exports = __webpack_public_path__ + "images/img_IP_5-919d04825c.png";